import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';

import { SidebarNavLink, SidebarWrapper } from '@components';
import { GlobalContext } from '@contexts';
import { datamodelsQuery } from '@queries';
import {
  ArrowLeftIcon,
  BallIcon,
  ClipboardIcon,
  ClockIcon,
  EditIcon,
  MapIcon,
  MapPinIcon,
  PageIcon,
  SearchIcon,
  SettingsIcon,
  UsersIcon,
} from '@svgs';

export const LocationSidebar = ({ businessID, locationID }) => {
  const { t, i18n } = useTranslation();
  const globals = useContext(GlobalContext);

  return (
    <SidebarWrapper>
      <div className="sb-sidebar-nav">
        <div className="sb-sidebar-header">
          <Link
            to={`/dashboard/projects/${businessID}/locations`}
            className="sb-sidebar-back-btn sb-flex"
          >
            <ArrowLeftIcon />
            Back to Project
          </Link>
        </div>
        <ul>
          {(globals.visible.locationTerritoriesView ||
            globals.visible.locationSocialView ||
            globals.visible.locationTerritoriesView) && (
            <>
              <li className="sb-sidebar-nav-title">Location details</li>
              {globals.visible.locationDetailsView && (
                <SidebarNavLink
                  to={`/dashboard/projects/${businessID}/locations/${locationID}/location_details`}
                  tooltip="Update the Location details including name, address, and phone numbers"
                >
                  <MapPinIcon />
                  Basic information
                </SidebarNavLink>
              )}
              {/**<SidebarNavLink to={`/dashboard/projects/${businessID}/locations/${locationID}/hours`}>
                <ClockIcon/>Hours of operation
              </SidebarNavLink>**/}
              {globals.visible.locationTerritoriesView && (
                <SidebarNavLink
                  to={`/dashboard/projects/${businessID}/locations/${locationID}/territories`}
                >
                  <MapIcon />
                  Territories
                </SidebarNavLink>
              )}
              {globals.visible.locationSocialView && (
                <SidebarNavLink
                  to={`/dashboard/projects/${businessID}/locations/${locationID}/social`}
                  tooltip="Update the links to social profiles"
                >
                  <BallIcon />
                  Social media
                </SidebarNavLink>
              )}
              {/**<SidebarNavLink to={`/dashboard/projects/${businessID}/locations/${locationID}/seo`}>
                <SearchIcon/>Local SEO
              </SidebarNavLink>**/}
            </>
          )}
        </ul>
      </div>
      <ul className="sb-sidebar-footer">
        {globals.visible.locationSettingsView && (
          <SidebarNavLink
            to={`/dashboard/projects/${businessID}/locations/${locationID}/settings`}
            tooltip="Update the settings for this Location"
          >
            <SettingsIcon />
            Location settings
          </SidebarNavLink>
        )}
      </ul>
    </SidebarWrapper>
  );
};
